import { ModalCommercialsBenefits } from 'src/components/sections/ProductDetails/ModalCommercialsBenefits'
import { useState } from 'react'
import { makeEventTrack, sendEvent } from 'src/utils/restructure/analytics'
import type { CommercialBenefit } from 'src/components/product-page/context/types/product.type'
import classNames from 'classnames'

import { useProductPageContext } from '../../contexts'
import { BenefitsItem } from './BenefitsItem'

type Props = {
  isMobileFirstFoldRevamp?: boolean
}

const CONTAINER_CLASSES =
  'restructure-tablet:px-md mt-14 mb-lg restructure-tablet:border restructure-tablet:border-solid restructure-tablet:border-[#D9DDE1] restructure-tablet:bg-restructure-background-primary restructure-tablet:pt-4'

const CONTENT_CLASSES = {
  default:
    'flex flex-col items-start text-restructure-tertiary gap-4 restructure-tablet:gap-6',
  revamp: 'flex flex-col items-start text-restructure-tertiary gap-1',
} as const

export function CommercialBenefits({ isMobileFirstFoldRevamp = false }: Props) {
  const styleVariant = isMobileFirstFoldRevamp ? 'revamp' : 'default'

  const {
    currentSku: { commercialsBenefits },
  } = useProductPageContext()

  const [isOpen, setIsOpen] = useState(false)
  const [dataModal, setDataModal] = useState(commercialsBenefits[0])

  const handleOnClick = (commercialBenefit: CommercialBenefit) => {
    setDataModal(commercialBenefit)
    setIsOpen(true)

    const event = makeEventTrack({
      eventAction: 'saiba mais',
      eventPage: 'pagina de produto',
    })

    sendEvent(event)
  }

  return (
    <div
      className={classNames(
        {
          [CONTAINER_CLASSES]: !isMobileFirstFoldRevamp,
        },
        {
          'restructure-tablet:pb-7':
            !isMobileFirstFoldRevamp && commercialsBenefits?.length > 1,
          'restructure-tablet:pb-4':
            !isMobileFirstFoldRevamp && commercialsBenefits?.length === 1,
        }
      )}
    >
      <div className={CONTENT_CLASSES[styleVariant]}>
        {commercialsBenefits?.map((benefit, index) => {
          return (
            <BenefitsItem
              key={index}
              item={benefit}
              isMobileFirstFoldRevamp={isMobileFirstFoldRevamp}
              onClickButton={handleOnClick}
            />
          )
        })}
      </div>
      <ModalCommercialsBenefits
        handleCloseCommercialsBenefitsModal={setIsOpen}
        openModalCommercialsBenefits={isOpen}
        comercialBenefitsData={dataModal}
      />
    </div>
  )
}
